import React, { useEffect, useState } from "react";
import classNames from "classnames";
import css from "./style.scss";
import { useDispatch, useSelector } from "react-redux";
import Modal from "components/base/Modal";
import micOff from "assets/images/mic_off.svg";
import { openClickToDial } from "data/user/actions";

const MicrophoneNotDetected = ({onRetry, onIgnore}) => {
  const dispatch = useDispatch();

  return (
    <Modal
      isOpen={true}
      isCloseButton={false}
      uniqId="MicrophoneNotDetectedModal"
      borderRadius="12px"
      zIndex={998}
      modalClassName={css.microphoneNotDetectedModal}
      className={classNames(css.clsClickToDialModals)}
      onClose={() => dispatch(openClickToDial(false))}
    >
      <div className={css.clsWrapper}>
        <div className={css.clsMain}>
          <div>
            <img width={90} src={micOff} alt="micOff" />
          </div>

          <div className={css.clsContent}>
            <div className={css.clsTitle}>
              <span>Microphone Not Detected</span>
            </div>
            <div className={css.clsText}>
              We were unable to detect a microphone on your computer. The
              permission settings on your browser may be blocking microphone
              access.
            </div>
          </div>
        </div>
        <div className={css.clsBtnWrapper}>
          <button
            className={css.cancelBtn}
            onClick={onIgnore}
          >
            <span className={css.cancelBtnLabel}>Ignore</span>
          </button>

          <button className={css.upgradeBtn} onClick={onRetry}>
            <span className={css.upgradeBtnTxt}>Retry</span>
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default MicrophoneNotDetected;
